import Splide from '@splidejs/splide';

export default function initGalleryBlock() {
    document.querySelectorAll<HTMLElement>('.js-gallery').forEach($gallery => {
        new GalleryBlock($gallery).init();
    });
}

type SliderSize = { height: number, width: number };

class GalleryBlock {
    $gallery: HTMLElement;

    constructor($gallery: HTMLElement) {
        this.$gallery = $gallery;
    }

    /**
     * Initialise la galerie
     * 
     * @return {void}
     */
    init(): void {
        this.getSliderLargestSizes().then(sliderSize => {
            this.$gallery.classList.add('initialized');
            new Splide(this.$gallery, {
                type: 'loop',
                drag: true,
                pagination: false,
                keyboard: false,
                arrowPath: 'M17.0319 25.4054C16.739 25.1125 16.739 24.6376 17.0319 24.3447L21.3765 20L17.0319 15.6554C16.739 15.3625 16.739 14.8876 17.0319 14.5947C17.3248 14.3018 17.7996 14.3018 18.0925 14.5947L22.4372 18.9394C23.023 19.5252 23.023 20.4749 22.4372 21.0607L18.0925 25.4054C17.7996 25.6983 17.3248 25.6983 17.0319 25.4054Z',
                height: sliderSize.height + 'px',
                width: sliderSize.width + 'px',
            }).mount();
        });
    }

    /**
     * Retourne une promesse contenant la hauteur et largeur max de la galerie
     * 
     * @return {Promise<SliderSize>}
     */
    getSliderLargestSizes(): Promise<SliderSize> {
        return new Promise(resolve => {
            const $slidesImg = this.$gallery.querySelectorAll<HTMLImageElement>('.splide__slide img');

            let sliderHeight = 0;
            let sliderWidth = 0;
            let nbImgLoaded = 0;

            // On cherche la plus grande hauteur et largeur d'image
            $slidesImg.forEach($slideImg => {
                $slideImg.onload = () => {
                    const slideImgHeight = $slideImg.clientHeight;
                    const slideImgWidth = $slideImg.clientWidth;

                    sliderHeight = slideImgHeight > sliderHeight ? slideImgHeight : sliderHeight;
                    sliderWidth = slideImgWidth > sliderWidth ? slideImgWidth : sliderWidth;
                    
                    // Lorsque toutes les images sont chargées, on resoud la promesse
                    nbImgLoaded++;
                    if (nbImgLoaded === $slidesImg.length) {
                        resolve({
                            height: sliderHeight,
                            width: sliderWidth,
                        });
                    }
                };
            });
        });
    }
}
